export enum PermissionEnum {
    Player = 1,
    Admin = 2
}
